var _circle, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "animate-spin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.5,
    stroke: "#5444F2",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75937 16.996C7.20657 17.0434 5.67047 16.6644 4.31798 15.9C2.96549 15.1357 1.84834 14.0153 1.08791 12.6606L2.81672 11.6902C3.39978 12.7289 4.25637 13.588 5.2934 14.174C6.33044 14.7601 7.50825 15.0508 8.69888 15.0144L8.75937 16.996Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75937 16.996C7.20657 17.0434 5.67047 16.6644 4.31798 15.9C2.96549 15.1357 1.84834 14.0153 1.08791 12.6606L2.81672 11.6902C3.39978 12.7289 4.25637 13.588 5.2934 14.174C6.33044 14.7601 7.50825 15.0508 8.69888 15.0144L8.75937 16.996Z",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_1_3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.26e03369dfc35410f15910843359ef20.svg";
export { ForwardRef as ReactComponent };